import { createReducer, on } from '@ngrx/store';
import { UserSettingsActions } from './user-settings.actions';
import { UserSettingsState, initialUserSettingsState } from './models/user-settings-state.models';

export const userSettingsReducer = createReducer(
  initialUserSettingsState,

  // Load settings
  on(UserSettingsActions.loadSettings, (state): UserSettingsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserSettingsActions.loadSettingsSuccess, (state, { settings }): UserSettingsState => ({
    ...state,
    settings,
    loading: false,
    error: null,
    cacheTimestamp: Date.now()
  })),
  on(UserSettingsActions.loadSettingsFailure, (state, { error }): UserSettingsState => ({
    ...state,
    loading: false,
    error
  })),

  // Update settings
  on(UserSettingsActions.updateSettings, (state): UserSettingsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserSettingsActions.updateSettingsSuccess, (state, { settings }): UserSettingsState => ({
    ...state,
    settings,
    loading: false,
    error: null,
    cacheTimestamp: Date.now()
  })),
  on(UserSettingsActions.updateSettingsFailure, (state, { error }): UserSettingsState => ({
    ...state,
    loading: false,
    error
  })),

  // Set settings directly
  on(UserSettingsActions.setSettings, (state, { settings }): UserSettingsState => ({
    ...state,
    settings,
    loading: false,
    error: null,
    cacheTimestamp: Date.now()
  })),

  // Clear settings
  on(UserSettingsActions.clearSettings, (): UserSettingsState => ({
    ...initialUserSettingsState
  })),

  // Invalidate cache
  on(UserSettingsActions.invalidateCache, (state): UserSettingsState => ({
    ...state,
    cacheTimestamp: null
  }))
);
